export default __webpack_public_path__ + "static/media/comunicaciones_fisicas_digitales.5d5a073a.svg";